﻿import { Centre, Country, School } from "app/shared/model";
import { FormMode, SchoolManagerState, initialState } from "./reducer";
import { normalizeSchoolId, toSchoolCacheKey } from "./actions";

const selectSlice = (state: any): SchoolManagerState => {
  return (
    state?.SchoolManager ||
    state?.schoolManager ||
    state?.pages?.SchoolManager ||
    state?.pages?.schoolManager ||
    state?.modules?.SchoolManager ||
    state?.modules?.schoolManager ||
    initialState
  );
};

export const selectCentres = (state: any): Centre[] => selectSlice(state).centres?.data ?? [];
export const selectCentresLoading = (state: any): boolean => !!selectSlice(state).centres?.loading;
export const selectCentresError = (state: any): string | undefined => selectSlice(state).centres?.error;

export const selectCountries = (state: any): Country[] => selectSlice(state).countries?.data ?? [];
export const selectCountriesLoading = (state: any): boolean => !!selectSlice(state).countries?.loading;

export const selectSelectedCentreId = (state: any): string | number | null => selectSlice(state).selectedCentreId ?? null;

export const selectSchools = (state: any): School[] => selectSlice(state).schools?.data ?? [];
export const selectSchoolsLoading = (state: any): boolean => !!selectSlice(state).schools?.loading;
export const selectSchoolsError = (state: any): string | undefined => selectSlice(state).schools?.error;

export const selectSelectedSchoolId = (state: any): string | number | null => selectSlice(state).selectedSchoolId ?? null;

export const selectSchoolDetailsMap = (state: any): Record<string | number, School> => selectSlice(state).schoolDetails ?? {};

export const selectSelectedSchoolDetail = (state: any): School | undefined => {
  const slice = selectSlice(state);
  const id = slice.selectedSchoolId;
  if (id == null) return undefined;

  const key = toSchoolCacheKey(id) ?? String(id);
  const byKey = slice.schoolDetails?.[key];
  if (byKey) return byKey;

  const numericKey = normalizeSchoolId(id);
  return numericKey ? slice.schoolDetails?.[numericKey] : undefined;
};


export const selectDetailLoadingId = (state: any): string | number | null => selectSlice(state).detailLoadingId ?? null;
export const selectDetailError = (state: any): string | undefined => selectSlice(state).detailError;

export const selectSaving = (state: any): boolean => !!selectSlice(state).saving;
export const selectSaveError = (state: any): string | undefined => selectSlice(state).saveError;

export const selectFormMode = (state: any): FormMode => selectSlice(state).formMode ?? "create";